import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import RavenUtil from '../ravenUtil';
import { strings, getCurrentLocale } from '../../../localization';

export default class StreamingBadge extends React.PureComponent {

    render() {
        let badgeText = "";
        const durationText = moment.duration(this.props.duration * 1000).humanize();
        badgeText = durationText;
        const currentLocale = this.props.currentLocale ? this.props.currentLocale : getCurrentLocale(); // check if locale already provided, to avoid redundant calls to this function
        if (this.props.media) {

            for (let i = this.props.media.length - 1; i >= 0; i -= 1) { // archives are typically the last item in these media arrays, therefore checking last item first

                if (this.props.media[i].type === "MEDIA_STREAMING_ARCHIVE") {

                    const mediaStreamingArchiveCreationTs = (this.props.level && this.props.level > 0) ? this.props.level 
                                                                                                        : this.props.media[i].ts.endsWith("Z") ? 
                                                                                                            this.props.media[i].ts 
                                                                                                            : this.props.media[i].ts + "Z";

                    badgeText += " · " + strings.event_media_created_at + " " + RavenUtil.toDate(mediaStreamingArchiveCreationTs).toLocaleTimeString(currentLocale, {month: "short", day: "numeric", hour: "numeric", minute: "numeric"});;

                    break;
                }
            }
        }
        return (
            <div className="idling-badge">
                {badgeText}
            </div>
        )
    }
}

StreamingBadge.propTypes = {
   duration : PropTypes.number.isRequired,
   archiveCreationString: PropTypes.string
};
